import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../services/alert.service';
import {EnvService} from '../services/env.service';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'micro-hosting-platform-detail',
  templateUrl: './cmdb-network-profile-detail.component.html'
})
export class CmdbNetworkProfileDetailComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  @Input() networkProfileId: any;
  @Output() persisted = new EventEmitter<any>();
  networkProfile: any;

  classCodeName: any = '';
  selectedClassCode: any;

  hostingPlatformName: any = '';
  selectedHostingPlatform: any;

  subnetName: any = '';
  selectedSubnet: any;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient, private route: ActivatedRoute,
              private router: Router, private alertService: AlertService) {
  }

  ngOnInit(): void {
    if (this.networkProfileId) {
      this.load(this.networkProfileId);

    } else {
      this.route.params.subscribe((params: Params) => {
        params['id'] === '0' ? this.createNew() : this.load(params['id']);
      });
    }
  }

  load(id: string): void {
    this.http.get(`${this.env.e.url}/domain/cmdbNetworkProfiles/${id}`).subscribe(data => {
      this.networkProfile = data
    });
  }

  createNew(): void {
    // This is a hack to get the form to work with a new object.
    this.networkProfile = { code: '', name: '', description: '', active: 'Y', hostingPlatformId: undefined, classCodeId: undefined, subnetId: undefined, companyId: this.auth.getCompanyId() };
  }

  save(): void {
    const isUpdate = !!this.networkProfile.id;
    const request = isUpdate
      ? this.http.put(`${this.env.e.url}/domain/cmdbNetworkProfiles`, this.networkProfile)
      : this.http.post(`${this.env.e.url}/domain/cmdbNetworkProfiles`, this.networkProfile);
    request.subscribe(data => {
      this.networkProfile = data;
      this.alertService.info(`${isUpdate ? 'Updated' : 'Created'} ${this.networkProfile.name}`);
      this.persisted.emit({data, action: isUpdate ? 'updated' : 'added'});
    });
  }

  delete(): void {
    this.http.delete(`${this.env.e.url}/domain/cmdbNetworkProfiles/${this.networkProfile.id}`).subscribe(() => {
      this.persisted.emit({data: this.networkProfile, action: 'deleted'});
      this.alertService.info(`Deleted ${this.networkProfile.name}`);
      if (!this.networkProfileId) { this.router.navigate(['/cmdbNetworkProfiles']); }
    });
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.networkProfile.active = target.checked ? 'Y' : 'N'
  }

  onClassCodeChange(classCode: any): void {
    this.selectedClassCode = classCode;
    this.classCodeName = classCode ? classCode.name : '';
  }

  onHostingPlatformChange(hostingPlatform: any): void {
    this.selectedHostingPlatform = hostingPlatform;
    this.hostingPlatformName = hostingPlatform ? hostingPlatform.name : '';
  }

    onSubnetChange(subnet: any): void {
    this.selectedSubnet = subnet;
    this.subnetName = subnet ? subnet.name : '';
  }

}
